import React from "react";
import { useIntl } from "react-intl";
import { AxiosError } from "axios";

import { type ClassificationConfiguration } from "@/schemas";

import { ClassificationConfigurationModalTemplate } from "./classification-configuration-modal.template";

export interface ClassificationConfigurationModalProps {
	readonly open: boolean;
	readonly defaultValues?: ClassificationConfiguration;
	readonly onSubmit: (data: ClassificationConfiguration) => Promise<void>;
	readonly onClose: () => void;
	readonly error: Error | null;
}

export const ClassificationConfigurationModal: React.FC<ClassificationConfigurationModalProps> = ({
	open,
	onClose,
	onSubmit,
	defaultValues,
	error,
}) => {
	const intl = useIntl();

	const getErrorMessage = (error: Error | null): string | undefined => {
		if (error === null) {
			return undefined;
		}

		if (error instanceof AxiosError && error.status === 409) {
			return intl.formatMessage({
				id: "A Classification already exists with this alias or number",
				defaultMessage: "A Classification already exists with this alias or number",
			});
		}

		if (error instanceof AxiosError && error.status === 404) {
			return intl.formatMessage({
				id: "Classification not found",
				defaultMessage: "Classification not found",
			});
		}

		if (error instanceof AxiosError && error.status === 400) {
			return intl.formatMessage({
				id: "Bad request",
				defaultMessage: "Bad request",
			});
		}

		return intl.formatMessage({
			id: "Unknown error, please try again",
			defaultMessage: "Unknown error, please try again",
		});
	};

	return (
		<ClassificationConfigurationModalTemplate
			open={open}
			onClose={onClose}
			onSubmit={onSubmit}
			defaultValues={defaultValues}
			errorMessage={getErrorMessage(error)}
		/>
	);
};
